import { useCurrentMedication } from '@/hooks/useCurrentMedication'

import { useState } from 'react'

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { CSTeamView, PatientView } from './contact-patient-section'
import { useFlag } from '@unleash/proxy-client-react'
import { X } from 'lucide-react'
import { useMedicationRequestStore } from '@/lib/stores/medication-request'

const tabs = ['patient', 'cs-team']

const RejectionReasonSection = () => {
  const { setSidebarView } = useMedicationRequestStore.getState()
  const medRequest = useCurrentMedication()
  const data = medRequest?.data
  const isRejectionFanEnabled = useFlag('rejection-fan') || data?.rejectionConversationId || !!import.meta.env.DEV

  const [prompt, setPrompt] = useState('')
  const [isGenerationViewActive, setIsGenerationViewActive] = useState(false)
  const [aiResponse, setAiResponse] = useState('')

  const [activeTab, setActiveTab] = useState<'patient' | 'cs-team'>('patient')

  const isPatientTabActive = activeTab === 'patient'

  if (!data) return null

  return (
    <div className='sticky top-[88px] max-w-[300px] overflow-y-auto max-h-[88vh] flex min-w-[25vw] flex-col rounded-2xl border border-custom-neutral-200 shadow-[0px_0px_1px_0px_rgba(113,128,150,0.04),0px_4px_8px_0px_rgba(113,128,150,0.08)]'>
      <div className='p-6'>
        <div className='mb-2 flex justify-between items-center'>
          <p className='text-custom-neutral-600 text-xl font-semibold leading-[133.4%]'>Rejection Reason</p>
          <X
            className='w-6 h-6 text-custom-neutral-600 cursor-pointer'
            data-testid='close-icon'
            onClick={() => setSidebarView('navigation-menu')}
          />
        </div>
        <p className='text-custom-neutral-500 text-sm leading-[170%]'>
          Provide the reasons for rejecting the medication request.
        </p>
      </div>
      <div className='px-6 pb-6' data-testid='rejection-reason-section'>
        {isRejectionFanEnabled ? (
          <Tabs defaultValue={tabs[0]}>
            <TabsList className='w-full border-0 h-[75px] rounded-none p-0 text-[#080F30] mb-6 bg-white'>
              {tabs.map(tab => (
                <TabsTrigger
                  key={tab}
                  onClick={() => setActiveTab(tab as 'patient' | 'cs-team')}
                  className='w-full h-full text-base rounded-none data-[state=active]:border-b-2 data-[state=active]:border-[#080F30] data-[state=active]:shadow-none transition-all duration-200 ease-in-out data-[state=active]:font-semibold font-light'
                  value={tab}
                >
                  {tab === 'patient' ? 'Patient' : 'CS Team'}
                </TabsTrigger>
              ))}
            </TabsList>
            {isPatientTabActive ? (
              <PatientView
                isGenerationViewActive={isGenerationViewActive}
                setIsGenerationViewActive={setIsGenerationViewActive}
                prompt={prompt}
                setPrompt={setPrompt}
                aiResponse={aiResponse}
                setAiResponse={setAiResponse}
                isRejection
              />
            ) : (
              <CSTeamView isRejection />
            )}
          </Tabs>
        ) : (
          <CSTeamView isRejection />
        )}
      </div>
    </div>
  )
}

export default RejectionReasonSection
